// extracted by mini-css-extract-plugin
export default {"title":"ingredient-details-page_title__fWhTK"};